// App.js
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/navbar/navbar"; // Asegúrate de que la ruta sea correcta
import Home from "./pages/home/page"; // Asegúrate de tener estos componentes de página
import About from "./pages/aboutUs/page"; // Asegúrate de tener estos componentes de página
import Curriculum from "./pages/curriculum/page";

const App = () => {
  return (
    <div>
      <Router>
        {" "}
        {/* El Router envuelve todo */}
        <Header /> {/* Header que se muestra en todas las páginas */}
        <title>JKalith</title>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />

        <link
          href="https://fonts.googleapis.com/css2?family=Noto+Serif:ital,wght@0,100..900;1,100..900&family=Victor+Mono:ital,wght@0,100..700;1,100..700&display=swap"
          rel="stylesheet"
        ></link>
        <main>
          <Routes>
            <Route path="/" element={<Home />} /> {/* Página de inicio */}
            <Route path="/About" element={<About />} /> {/* Página de inicio */}
            <Route path="/Curriculum" element={<Curriculum />} />{" "}
            {/* Página de inicio */}
          </Routes>
        </main>
      </Router>
    </div>
  );
};

export default App;
